
(function($){
  var that = {};
  var savethedate_lib = that; // compat

  that.saveTheDateFormHandler = function () {
    $('#save_the_date').find('.btn').click(function (e) {
      e.preventDefault();
      if ($(this).hasClass("disabled-ajax")) {
        return;
      }

      var form = $(this).closest("#save_the_date");

      var url = form.attr('action'),
        subscribe = $('#save_the_date_subscribe').val();

      form.find(".btn").addClass("disabled-ajax");
      if (subscribe === "1") { // disable all session buttons
        $(".save_session .btn").addClass("disabled-ajax");
      }

      var post = $.post(url, {
        save_the_date_nonce: $('#save_the_date_nonce').val(),
        action: 'save_the_date',
        subscribe: subscribe
      });

      post.done(function (data) {
        var subscribeElem = $('#save_the_date_subscribe');
        var form = subscribeElem.parent();
        form.find(".btn").removeClass("disabled-ajax");
        $(".save_session .btn").removeClass("disabled-ajax");

        if (!data || data.success === false) {
          //helper.growlerror({message: data.data.error_message});
          //window.location.href = 'https://sso.vr-networld.de/index.php?p=login&lid=c3b14465bd3c052f08be9159f20d55fbac7e8711';
        } else {
          var form_thementag;
          if (data.data.subscribe === '0') {
            subscribeElem.val("1");
            form.find(".btn").addClass("btn-primary").removeClass("btn-default");

            var activated_thementage = data.data.activated_thementage;
            if (activated_thementage.length) {
              for (var i = 0; i < activated_thementage.length; i++) {
                form_thementag = $("form[data-session^=" + activated_thementage[i] + "]");
                form_thementag.find("[name='subscribe']").val("1");
                form_thementag.find(".btn").addClass("btn-primary").removeClass("btn-default");
                form_thementag.find(".save_the_date").text("Termin vormerken");
              }
            }
          } else {
            subscribeElem.val("0");
            form.find(".btn").removeClass("btn-primary").addClass("btn-default");
            $.fancybox.open([
              {
                href: form.find(".btn").attr("href")
              }
            ], {
              autoSize: true,
              width: 300
            });

            var deactivated_thementage = data.data.activated_thementage;
            if (deactivated_thementage.length) {
              for (var j = 0; j < deactivated_thementage.length; j++) {
                form_thementag = $("form[data-session^=" + deactivated_thementage[j] + "]");
                form_thementag.find("[name='subscribe']").val("0");
                form_thementag.find(".btn").removeClass("btn-primary").addClass("btn-default");
                form_thementag.find(".save_the_date").text("Termin gemerkt");
              }
            }
          }
          $('#save_the_date_caption').text(data.data.success_message);
        }
      });
      // Dont show ical if unsubscribe
      /*if(subscribe === '0') {
       e.preventDefault();
       }*/
    });
  };

  that.saveASessionFormHandler = function (isAdito) {
    var selector = '.save_session';
    var action = 'save_session';
    if(isAdito !== undefined && isAdito) {
      selector = '.save_session_crm';
      action = 'save_session_crm';
    }

    $('#topics, #header, #accordion').find(selector+' .btn').click(function (e) {
      e.preventDefault();
      if ($(this).hasClass("disabled-ajax")) {
        return;
      }

      var isAccordion = false;
      if ($(this).hasClass("save-accordion")) {
        isAccordion = true;
      }

      var spinner = $(this).parent().find('#loader');
      $(this).addClass('disabled');
      spinner.show();

      var form = $(this).closest(selector);
      form.find(".btn").addClass("disabled-ajax");

      var url = form.attr('action'),
        session = form.data('session'),
        subscribe = $('#save_session_' + session + '_subscribe').val();

      var post = {
        action: action,
        session: session,
        subscribe: subscribe,
        is_accordion: isAccordion
      };

      post = $.post(url, post);

      post.done(function (data) {
        spinner.hide();
        form.find(".btn").removeClass("disabled");
        if (typeof data.data === 'undefined') {
          window.location.href = 'https://sso.vr-networld.de/index.php?p=login&lid=c3b14465bd3c052f08be9159f20d55fbac7e8711';
        }
        form.find(".btn").removeClass("disabled-ajax");
        if (!data || data.success === false) {
          //helper.growlerror({message: data.data.error_message});
        } else {
          var subscribeElem = $('#save_session_' + data.data.session + '_subscribe');
          if (subscribe === '0') {
            subscribeElem.val("1");
            form.find(".btn").addClass("btn-primary").removeClass("btn-default");
          } else {
            subscribeElem.val("0");
            form.find(".btn").removeClass("btn-primary").addClass("btn-default");
            $.fancybox.open([
              {
                href: form.find(".btn").attr("href")
              }
            ], {
              autoSize: true,
              width: 300
            });
          }
          $('#save_session_' + data.data.session + '_caption').text(data.data.success_message);
        }
      });
    });
  };

  that.initSaveASession = function(data){
    var caption = null;
    if(data.length) {
      for(var i = 0; i < data.length; i++ ) {
        var sessionId = data[i].session;
        var subscribed = parseInt(data[i].saved);
        caption = $('#save_session_'+sessionId+'_caption');

        if(subscribed === 1) {
          caption.html('Termin gemerkt');
          caption.removeClass('btn-primary').addClass('btn-default');
          subscribed = 0;
        } else {
          caption.html('Termin vormerken');
          caption.removeClass('btn-default').addClass('btn-primary');
          subscribed = 1;
        }

        $('#save_session_'+sessionId+'_subscribe').val(subscribed);
      }
    } else {
      caption = $('.btn[id^="save_session_"]');
      caption.html('Termin vormerken');
      caption.removeClass('btn-default').addClass('btn-primary');
      $('[name="subscribe"][id^="save_session_"]').val(1);
    }
    $('.save_session_crm .btn').removeClass('disabled');
  };

  that.disableSaveButton = function() {
    $('.save_session_crm .btn').addClass('disabled');
  };

  window.vrnetworld.savethedate = that;
})(jQuery);
